<!-- Made with love -->
<div class="made-with">
    {{ 'nav_bar_menu_made_with_1' | translate }}<mat-icon class="heart-icon">favorite</mat-icon>{{ 'nav_bar_menu_made_with_2' | translate }}                                
</div>